/* TODO: switch to 'import ... from' syntax */
/* global require,module */

const ReduxModel = require('shared/lib/orm/reduxModel').default

const Model = {}

// ************************************************************
// Resources WITH defined associations
// ************************************************************

const documentModel = (type) => {
  return ReduxModel(type, {
    defaultValues: { tags: [] },
    hasMany: {
      lines: { namespace: Model },
      taxValues: { namespace: Model }
    },
    belongsTo: {
      customer: { namespace: Model },
      order: { namespace: Model },
      coupon: { namespace: Model }
    }
  })
}
Model.Document = documentModel('Document')
Model.Invoice = documentModel('Invoice')
Model.Contract = documentModel('Contract')
Model.Quote = documentModel('Quote')

Model.CheckoutItem = ReduxModel('CheckoutItem', {
  belongsTo: {
    default_property: { namespace: Model, key: 'default_property_id' }
  }
})

Model.Employee = ReduxModel('Employee', {
  defaultValues: { permissions: [] },
  hasMany: {
    notes: { key: 'employee_id', namespace: Model }
  }
})

Model.Order = ReduxModel('Order', {
  hasMany: {
    // vcard uses order.lines
    lines: { namespace: Model },
    // orderscreen uses order.tax_values
    taxValues: { namespace: Model }
  }
})

Model.Note = ReduxModel('Note', {
  belongsTo: {
    employee: { key: 'employee_id', namespace: Model }
  }
})

Model.PriceRule = ReduxModel('PriceRule', {
  defaultValues: {},
  belongsTo: {
    price_ruleset: { namespace: Model, key: 'price_ruleset_id' }
  }
})

Model.PriceRuleset = ReduxModel('PriceRuleset', {
  defaultValues: {},
  hasMany: {
    price_rules: { namespace: Model, foreignKey: 'price_ruleset_id' }
  }
})

Model.PriceStructure = ReduxModel('PriceStructure', {
  hasMany: {
    price_tiles: { namespace: Model, foreignKey: 'price_id' }
  }
})

Model.PriceTile = ReduxModel('PriceTile', {
  belongsTo: {
    price_structure: { namespace: Model, key: 'price_id' }
  }
})

Model.Product = ReduxModel('Product', {
  hasMany: {
    stockItems: { namespace: Model, foreignKey: 'item_id' }
  },
  hasOne: {
    barcode: { namespace: Model }
  },
  belongsTo: {
    photo: { namespace: Model }
  }
})

Model.ProductGroup = ReduxModel('ProductGroup', {
  hasMany: {
    products: { foreignKey: 'product_group_id', namespace: Model },
    stockItems: { through: 'products', namespace: Model },
    properties: { namespace: Model }
  },
  hasOne: {
    barcode: { namespace: Model },
    photo: { foreignKey: 'owner_id', namespace: Model }
  },
  belongsTo: {
    taxCategory: { namespace: Model }
  }
})

Model.StockCount = ReduxModel('StockCount', {
  belongsTo: {
    product: { namespace: Model, key: 'item_id' },
    stockItem: { namespace: Model, key: 'stock_item_id' }
  }
})

Model.StockItem = ReduxModel('StockItem', {
  belongsTo: {
    product: { namespace: Model, key: 'item_id' }
  },
  hasOne: {
    barcode: { namespace: Model }
  },
  hasMany: {
    orders: { namespace: Model }
  }
})

Model.Downtime = ReduxModel('Downtime', {
  belongsTo: {
    stockItem: { namespace: Model, key: 'stock_item_id' },
    product: { namespace: Model, key: 'product_id' },
    location: { namespace: Model, key: 'location_id' }
  }
})

Model.Transaction = ReduxModel('Transaction', {
  belongsTo: {
    payment: { namespace: Model, key: 'payment_id' }
  }
})

Model.User = ReduxModel('User', {
  belongsTo: {
    customer: { namespace: Model, key: 'customer_id' }
  }
})

// ************************************************************
// Resources without associations
// ************************************************************

Model.ActivityLog = ReduxModel('ActivityLog')
Model.App = ReduxModel('App')
Model.AppPaymentOption = ReduxModel('AppPaymentOption')
Model.AppPlan = ReduxModel('AppPlan')
Model.AppSubscription = ReduxModel('AppSubscription')
Model.AppSubscriptionPlan = ReduxModel('AppSubscriptionPlan')
Model.AppCarrier = ReduxModel('AppCarrier')
Model.Asset = ReduxModel('Asset')
Model.AuthenticationMethod = ReduxModel('AuthenticationMethod')
Model.Barcode = ReduxModel('Barcode')
Model.BillingInvoice = ReduxModel('BillingInvoice')
Model.BulkUpsert = ReduxModel('BulkUpsert')
Model.Bundle = ReduxModel('Bundle')
Model.BundleItem = ReduxModel('BundleItem')
Model.CancellationRequest = ReduxModel('CancellationRequest')
Model.Cluster = ReduxModel('Cluster')
Model.Collection = ReduxModel('Collection')
Model.CollectionItem = ReduxModel('CollectionItem')
Model.CollectionItemAssociation = ReduxModel('CollectionItemAssociation')
Model.CollectionTree = ReduxModel('CollectionTree')
Model.Company = ReduxModel('Company')
Model.Count = ReduxModel('Count')
Model.Country = ReduxModel('Country')
Model.Coupon = ReduxModel('Coupon')
Model.Creditcard = ReduxModel('Creditcard')
Model.Customer = ReduxModel('Customer')
Model.DefaultProperty = ReduxModel('DefaultProperty')
Model.DepositHold = ReduxModel('DepositHold')
Model.Email = ReduxModel('Email')
Model.EmailTemplate = ReduxModel('EmailTemplate')
Model.EmployeeInvitation = ReduxModel('EmployeeInvitation')
Model.ExternalImage = ReduxModel('ExternalImage')
Model.FeatureEnrollment = ReduxModel('FeatureEnrollment')
Model.Integration = ReduxModel('Integration')
Model.InventoryBreakdown = ReduxModel('InventoryBreakdown')
Model.InvoiceFinalization = ReduxModel('InvoiceFinalization')
Model.InvoiceRevision = ReduxModel('InvoiceRevision')
Model.IpAddress = ReduxModel('IpAddress')
Model.Item = ReduxModel('Item')
Model.ItemPrice = ReduxModel('ItemPrice')
Model.Line = ReduxModel('Line')
Model.LineChargeSuggestion = ReduxModel('LineChargeSuggestion')
Model.Locale = ReduxModel('Locale')
Model.Location = ReduxModel('Location')
Model.LocationCarrier = ReduxModel('LocationCarrier')
Model.LoginActivity = ReduxModel('LoginActivity')
Model.Menu = ReduxModel('Menu')
Model.MenuItem = ReduxModel('MenuItem')
Model.Merge = ReduxModel('Merge')
Model.OperatingRule = ReduxModel('OperatingRule')
Model.Operation = ReduxModel('Operation')
Model.OrderAvailability = ReduxModel('OrderAvailability')
Model.OrderDeliveryRate = ReduxModel('OrderDeliveryRate')
Model.OrderDeliveryRateRecalculation = ReduxModel('OrderDeliveryRateRecalculation')
Model.OrderDuplication = ReduxModel('OrderDuplication')
Model.OrderFulfillment = ReduxModel('OrderFulfillment')
Model.OrderPlanningAvailability = ReduxModel('OrderPlanningAvailability')
Model.OrderPriceRecalculation = ReduxModel('OrderPriceRecalculation')
Model.OrderStatusTransition = ReduxModel('OrderStatusTransition')
Model.Page = ReduxModel('Page')
Model.PaymentMethod = ReduxModel('PaymentMethod')
Model.PaymentProfile = ReduxModel('PaymentProfile')
Model.Payment = ReduxModel('Payment')
Model.PaymentAuthorization = ReduxModel('PaymentAuthorization', { stateKey: 'payments' })
Model.PaymentCharge = ReduxModel('PaymentCharge', { stateKey: 'payments' })
Model.PaymentRefund = ReduxModel('PaymentRefund', { stateKey: 'payments' })
Model.RefundablePaymentCharge = ReduxModel('RefundablePaymentCharge')
Model.Photo = ReduxModel('Photo')
Model.PlannableItem = ReduxModel('PlannableItem')
Model.Planning = ReduxModel('Planning')
Model.PriceWrapper = ReduxModel('PriceWrapper')
Model.ProductGroupDuplication = ReduxModel('ProductGroupDuplication')
Model.ProductTrackerActions = ReduxModel('ProductTracker')
Model.Property = ReduxModel('Property')
Model.Province = ReduxModel('Province')
Model.Publication = ReduxModel('Publication')
Model.RenderedEmail = ReduxModel('RenderedEmail')
Model.ReportProductFulfillment = ReduxModel('ReportProductFulfillment')
Model.ReportRental = ReduxModel('ReportRental')
Model.ReportRentalInterval = ReduxModel('ReportRentalInterval')
Model.ReportSalesItem = ReduxModel('ReportSalesItem')
Model.ReportStockItem = ReduxModel('ReportStockItem')
Model.Session = ReduxModel('Session')
Model.Signature = ReduxModel('Signature')
Model.Sorting = ReduxModel('Sorting')
Model.StockAdjustment = ReduxModel('StockAdjustment')
Model.StockItemArchivation = ReduxModel('StockItemArchivation')
Model.StockItemPlanning = ReduxModel('StockItemPlanning')
Model.StockItemSuggestion = ReduxModel('StockItemSuggestion')
Model.StockItemTracker = ReduxModel('StockItemTracker')
Model.Tag = ReduxModel('Tag')
Model.TaxCategory = ReduxModel('TaxCategory')
Model.TaxRate = ReduxModel('TaxRate')
Model.TaxRegion = ReduxModel('TaxRegion')
Model.TaxValue = ReduxModel('TaxValue')
Model.Theme = ReduxModel('Theme')
Model.Transfer = ReduxModel('Transfer')
Model.UserInvitation = ReduxModel('UserInvitation')

module.exports = Model
